import { ColorEnum } from '@/constants/color'
import { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const KitchenIcon: FC<SvgProps> = (props) => {
    return (
        <Svg fill="none" viewBox="0 0 16 16" width="16" height="16" {...props}>
            <Path
                stroke={ColorEnum.GRAY_900}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M11.333 14a.667.667 0 0 0 .667-.666V9.767c0-.304.21-.562.485-.694a2.667 2.667 0 0 0-1.423-5.059 3.333 3.333 0 0 0-6.124 0 2.667 2.667 0 0 0-1.423 5.059c.274.132.485.39.485.694v3.567a.667.667 0 0 0 .667.667h6.666ZM4 11.334h8"
            />
        </Svg>
    )
}

export default KitchenIcon
